import React from 'react';

import { OptionalText, SmsTermsLink } from './SmsConsentLabel.styled';

const smsTermsUrl = 'https://kindbody.com/sms-terms-2024/';

export const SmsConsentLabel: React.FC = () => {
  return (
    <>
      <OptionalText>(OPTIONAL)</OptionalText>
      By checking the box and opting in, I agree to receive{' '}
      <SmsTermsLink href={smsTermsUrl} target="_blank" rel="noopener noreferrer">
        SMS messages regarding my account, services, updates, notifications, and other related
        communications from Kindbody.
      </SmsTermsLink>{' '}
      Message frequency varies. Message and data rates may apply. Reply STOP to opt out at any time.
      Reply HELP for help. By leaving this box unchecked, I will not be opted into this short code
      campaign.
    </>
  );
};
